var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_115_4",
    "data-name": "Component 115 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.597,
    height: 14.712,
    viewBox: "0 0 25.597 14.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12605",
    "data-name": "Group 12605",
    transform: "translate(-397.625 -270.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-view-1014495",
    transform: "translate(397.625 270.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13520",
    "data-name": "Path 13520",
    d: "M243.209,364.779a13.333,13.333,0,0,0,17.981,0,23.641,23.641,0,0,0,3.678-3.46.735.735,0,0,0,0-.872,28.938,28.938,0,0,0-3.678-3.405,13.333,13.333,0,0,0-17.981,0,23.242,23.242,0,0,0-3.651,3.433.735.735,0,0,0,0,.872,23.245,23.245,0,0,0,3.651,3.433Zm8.991-9.863c5.313,0,9.89,4.55,11.225,5.994-1.335,1.444-5.912,5.994-11.225,5.994s-9.89-4.55-11.225-5.994C242.309,359.466,246.887,354.916,252.2,354.916Z",
    transform: "translate(-239.415 -353.554)",
    fill: "#24abe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13521",
    "data-name": "Path 13521",
    d: "M681.4,494.292a5.04,5.04,0,1,0-5.04-5.04A5.046,5.046,0,0,0,681.4,494.292Zm0-8.718a3.678,3.678,0,1,1-3.678,3.678A3.7,3.7,0,0,1,681.4,485.574Z",
    transform: "translate(-668.615 -481.896)",
    fill: "#24abe2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.ba6f4c1755e4cf12a06816f6fe1b9b42.svg";
export { ForwardRef as ReactComponent };